export enum DemurrageDetentionStatusEnum {
  AtRisk = 'AT_RISK',
  Breached = 'BREACHED',
  Ok = 'OK',
  NotAvailable = 'NOT_AVAILABLE',
  NoFreeDays = 'NO_FREE_DAYS',
  Unprocessed = 'UNPROCESSED',
}
